import Box from '@mui/material/Box'
import { Person20Regular } from '@/components/Icon'
import { getSettingsSectionIntro } from '@/components/Settings/settingsSectionDescriptions'
import PlanUsageCardShell from './PlanUsageCardShell.jsx'
import { buildHeatColumnsFromUsage } from './PlanUsageActivityHeatmap/planUsageHeatmapFromUsage.js'
import { PlanUsageActivityHeatmapGrid } from './PlanUsageActivityHeatmap/PlanUsageActivityHeatmapGrid.jsx'
import { PlanUsageActivityHeatmapLegend } from './PlanUsageActivityHeatmap/PlanUsageActivityHeatmapLegend.jsx'

/** @param {{ series?: { bucket: string, total_tokens: number }[] }} props */
export default function PlanUsageActivityHeatmap({ series }) {
  const columns = buildHeatColumnsFromUsage(series)
  return (
    <PlanUsageCardShell
      sectionAriaLabel="User activity heatmap"
      title="User activity"
      titleIcon={<Person20Regular />}
      intro={getSettingsSectionIntro('plan-activity')}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'stretch',
          width: '100%',
          minWidth: 0,
          borderRadius: '10px',
          py: 3,
          gap: 1.25,
          boxSizing: 'border-box',
          transform: 'scale(0.985)',
          transformOrigin: 'top center',
        }}
      >
        <PlanUsageActivityHeatmapGrid columns={columns} />
        <PlanUsageActivityHeatmapLegend />
      </Box>
    </PlanUsageCardShell>
  )
}
